module.exports = __webpack_public_path__ + "static/media/thumb_nomad_503x503.b67a16f7.jpg";